import type { ApiConfig } from '../../types'

/**
 * Backpack の borrow lend 履歴 API 設定。
 * `/wapi/v1/history/borrowLend` (instruction: borrowHistoryQueryAll) を利用する。
 * 借入 (Borrow) と返済 (BorrowRepay) のみを対象とし、Lend / LendRedeem は取引所内の残高移動のため対象外。
 *
 * 本 endpoint は `from` / `to` フィルタをサポートせず、offset ベースの pagination のみ。
 * このため `fetchApiData` 内部で全ページを取得する設計とし、 `limit` には framework の
 * "count < limit ⇒ 全取得済" 判定が常に成立する大きな値を設定する。
 */
export const borrowLendHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1_000_000,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'borrow-lend-history',
} as const satisfies ApiConfig
